import React from 'react';
import PropTypes from 'prop-types';
import Stats from './Stats';
import Stopwatch from './Stopwatch'

const Header = (props) => {

  /* Destructuring assignment used to unpack values from arrays
  or prorperties from objects into distinct variables.
  Developers often use destructuring in React to make components 
  cleaner, more concise, and easier to understand.
  Used in components that accept props */
  const { players, title } = props;

  return (
    <header>
      <Stats players={players} />
      <h1>{title}</h1>
      <Stopwatch />
    </header>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  players: PropTypes.arrayOf(PropTypes.object)
}

Header.defaultProps = {
  title: 'Scoreboard'
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js